module.exports = __webpack_public_path__ + "img/driversLicenseExampleFrontOutlined.1e38e5aa.svg";